import React from 'react';
import t from 'react-translate';
import { openConfirmationDialog } from 'redux/actions/confirmation-dialogs';
import { disableOrgLevelCredlySettings } from 'redux/actions/credly';
import { disableHCMIntegration } from 'redux/actions/hcm';
import store from 'redux/store';
import { wrapThunkAction } from 'redux/utils';
import { HCMSettingsPayload } from 'redux/schemas/models/hcm';
import { addAlertMessage } from '../../redux/actions/alert-messages';
import { AlertMessageType } from '../../redux/schemas/app/alert-message';
import CredlySettings from '../components/credly-settings';
import HCMIntegration from '../components/hcm-integration';
import HCMDataMapping from '../components/hcm-data-mapping';
import OrgLevelMetadataSettings from '../components/org-level-metadata-settings';
import OrgLevelProfileSettings from '../components/org-level-profile-settings';
import AutomatedTranslationSwitch from '../components/automated-translation-switch';
import AdvancedSettingsSwitch from '../components/advanced-settings-switch';

export const providerTypes = {
  SABA: 'saba',
  SUMTOTAL: 'sum_total',
};

/* @ngInject */
export default function InstitutionAdvancedSettingsCtrl(
  $state,
  $scope,
  $uibModal,
  RailsRoutes,
  AlertMessages,
  CurrentUserManager,
  InstitutionsManager,
  validationConstants,
  StateManager,
  CurrentPermissionsManager,
  config,
  _,
  $translate,
) {
  $scope.StateManager = StateManager;

  const vm = this;

  initialize();
  vm.config = config;

  vm.InstitutionsManager = InstitutionsManager;
  vm.CurrentPermissionsManager = CurrentPermissionsManager;
  vm.validationConstants = validationConstants;
  vm.nameEditsDisabled = !vm.InstitutionsManager.institution.enableBasicSsoInfoEdit;
  vm.getZoomOauthDisableArticleLink = 'https://help.novoed.com/hc/en-us/articles/360061031512';

  vm.updateFaviconOnPage = () => {
    vm.InstitutionsManager.updateFavicon(vm.InstitutionsManager.institution.favicon);
  };

  vm.saveFavicon = ($file) => {
    InstitutionsManager.institution.favicon = $file;
    InstitutionsManager.updateBrand().then(() => {
      vm.updateFaviconOnPage();
    }, (errorResponse) => {
      $.noop();
      AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.NOT_SUPPORTED_ALERT');
      // console.log(errorResponse);
    });
  };

  vm.removeFavicon = () => {
    InstitutionsManager.institution.favicon = null;
    InstitutionsManager.updateBrand().then(() => {
      vm.updateFaviconOnPage();
    });
  };

  vm.configureSSO = () => {
    InstitutionsManager.backupProviderData();

    $uibModal.open({
      templateUrl: 'institutions/templates/configure-sso-modal.html',
      controller: 'ConfigureSSOModalCtrl as vm',
      resolve: {
      },
    });
  };

  vm.enableWelcomeEmail = () => {
    InstitutionsManager.enableWelcomeEmail();
  };

  vm.disableWelcomeEmail = () => {
    InstitutionsManager.disableWelcomeEmail();
  };

  vm.configureTOS = () => {
    $uibModal.open({
      templateUrl: 'institutions/templates/configure-tos-modal.html',
      controller: 'ConfigureTOSModalCtrl as vm',
      resolve: {
      },
    });
  };

  vm.nameEditsCheckboxClicked = () => {
    vm.InstitutionsManager.setBasicSSOInfoEdit(!vm.nameEditsDisabled);
  };

  vm.onSearchSettingChanged = () => {
    InstitutionsManager.toggleOrgSearchAllUsers();
  };

  vm.switchAvailabilityFileDownload = (value) => {
    InstitutionsManager.institution.allowFileDownloads = value;

    const failureCallback = () => {
      AlertMessages.error('FORM.OOPS', 'FORM.ERROR_SOMETHING_WRONG');
      InstitutionsManager.institution.allowFileDownloads = !InstitutionsManager.institution.allowFileDownloads;
    };
    InstitutionsManager.toggleAvailabilityFileDownload(InstitutionsManager.institution.allowFileDownloads)
      .then((success) => {
        if (!success) {
          failureCallback();
        }
      }, () => {
        failureCallback();
      });
  };

  vm.switchVideoPracticeInsights = (value) => {
    InstitutionsManager.institution.videoPracticeInsightsEnabled = value;

    const failureCallback = () => {
      AlertMessages.error('FORM.OOPS', 'FORM.ERROR_SOMETHING_WRONG');
      InstitutionsManager.institution.videoPracticeInsightsEnabled = !InstitutionsManager.institution.videoPracticeInsightsEnabled;
    };

    const toggleVideoPracticeInsights = () => {
      InstitutionsManager.toggleVideoPracticeInsights(InstitutionsManager.institution.videoPracticeInsightsEnabled)
        .then((success) => {
          if (!success) {
            failureCallback();
          }
        }, () => {
          failureCallback();
        });
    };
    if (!vm.InstitutionsManager.institution.videoPracticeInsightsEnabled) {
      const disableConfirmationModal = $uibModal.open({
        backdrop: 'static',
        backdropClass: 'modal-overlay-backdrop',
        templateUrl: 'institutions/templates/disable-video-practice-insights-confirmation.html',
        windowClass: 'modal-overlay',
      });
      disableConfirmationModal.result.then(() => {
        toggleVideoPracticeInsights();
      }).catch(() => {
        InstitutionsManager.institution.videoPracticeInsightsEnabled = !InstitutionsManager.institution.videoPracticeInsightsEnabled;
      });
    } else {
      toggleVideoPracticeInsights();
    }
  };

  vm.switchAppPromotion = (value) => {
    InstitutionsManager.institution.isAppPromotionEnabled = value;

    const failureCallback = () => {
      AlertMessages.error('FORM.OOPS', 'FORM.ERROR_SOMETHING_WRONG');
      InstitutionsManager.institution.isAppPromotionEnabled = !InstitutionsManager.institution.isAppPromotionEnabled;
    };

    const toggleAppPromotion = () => {
      InstitutionsManager.toggleAppPromotion(InstitutionsManager.institution.isAppPromotionEnabled)
        .then((success) => {
          if (!success) failureCallback();
        }, () => {
          failureCallback();
        });
    };

    if (!vm.InstitutionsManager.institution.isAppPromotionEnabled) {
      const disableConfirmationModal = $uibModal.open({
        backdrop: 'static',
        backdropClass: 'modal-overlay-backdrop',
        templateUrl: 'institutions/templates/disable-app-promotion-confirmation.html',
        windowClass: 'modal-overlay',
      });
      disableConfirmationModal.result.then(() => {
        toggleAppPromotion();
      }).catch(() => {
        InstitutionsManager.institution.isAppPromotionEnabled = !InstitutionsManager.institution.isAppPromotionEnabled;
      });
    } else {
      toggleAppPromotion();
    }
  };

  vm.hasZoomIntegration = () => (
    vm.InstitutionsManager.hasIntegration(vm.InstitutionsManager.INTEGRATION_TYPES.ZOOM_JWT)
    || vm.InstitutionsManager.hasIntegration(vm.InstitutionsManager.INTEGRATION_TYPES.ZOOM_USER_LEVEL)
    || vm.InstitutionsManager.hasIntegration(vm.InstitutionsManager.INTEGRATION_TYPES.ZOOM_ACCOUNT_LEVEL)
  );

  vm.getZoomIntegrationType = () => {
    if (vm.hasZoomIntegration()) {
      if (vm.InstitutionsManager.hasIntegration(vm.InstitutionsManager.INTEGRATION_TYPES.ZOOM_ACCOUNT_LEVEL)) {
        return vm.InstitutionsManager.INTEGRATION_TYPES.ZOOM_ACCOUNT_LEVEL;
      } if (vm.InstitutionsManager.hasIntegration(vm.InstitutionsManager.INTEGRATION_TYPES.ZOOM_USER_LEVEL)) {
        return vm.InstitutionsManager.INTEGRATION_TYPES.ZOOM_USER_LEVEL;
      }
      return vm.InstitutionsManager.INTEGRATION_TYPES.ZOOM_JWT;
    }
    return null;
  };

  vm.configureZoom = (mode) => {
    $uibModal.open({
      templateUrl: 'institutions/templates/configure-zoom-modal.html',
      controller: 'ConfigureZoomModalCtrl as vm',
      resolve: {
        mode: () => mode,
      },
    });
  };

  vm.enableMicrosoft = () => {
    InstitutionsManager.saveLiveSessionSettings(null, null, InstitutionsManager.INTEGRATION_TYPES.MS_TEAMS_USER_LEVEL)
      .then((isValid) => {
        if (isValid) {
          InstitutionsManager.institution.liveSessionSettings.source = [
            ...InstitutionsManager.institution.liveSessionSettings?.source,
            InstitutionsManager.INTEGRATION_TYPES.MS_TEAMS_USER_LEVEL,
          ];

          AlertMessages.success('FORM.SUCCESS_BANG', 'INSTITUTIONS.ADVANCED_SETTINGS.MICROSOFT_INTEGRATION.ENABLE_SUCCESS');
        }
      }, () => {
        AlertMessages.error('FORM.OOPS', 'FORM.ERROR_SOMETHING_WRONG');
      });
  };

  vm.disableMicrosoft = () => {
    const disableMsConfirmationModal = $uibModal.open({
      backdrop: 'static',
      backdropClass: 'modal-overlay-backdrop',
      templateUrl: 'institutions/templates/disable-ms-confirmation.html',
      windowClass: 'modal-overlay',
    });
    disableMsConfirmationModal.result.then(() => {
      InstitutionsManager.disableLiveSessionSettings(InstitutionsManager.INTEGRATION_TYPES.MS_TEAMS_USER_LEVEL)
        .then((isValid) => {
          if (isValid) {
            InstitutionsManager.institution.liveSessionSettings = {
              source: _.without(
                InstitutionsManager.institution.liveSessionSettings.source,
                InstitutionsManager.INTEGRATION_TYPES.MS_TEAMS_USER_LEVEL,
              ),
            };
            AlertMessages.success('FORM.SUCCESS_BANG', 'INSTITUTIONS.ADVANCED_SETTINGS.MICROSOFT_INTEGRATION.DISABLE_SUCCESS');
          } else {
            AlertMessages.success('OOPS', 'ERROR_SOMETHING_WRONG');
          }
        });
    });
  };

  vm.configureCalendar = () => {
    window.location.href = RailsRoutes.authenticateMicrosoftCalendarOauthUrl(InstitutionsManager.institution.id);
  };

  vm.configureDegreed = () => {
    $uibModal.open({
      templateUrl: 'institutions/templates/configure-degreed-modal.html',
      controller: 'ConfigureDegreedModalCtrl as vm',
      resolve: {
      },
    });
  };

  vm.configureLms = () => {
    $uibModal.open({
      templateUrl: 'institutions/templates/configure-lms-modal.html',
      controller: 'ConfigureLmsModalCtrl as vm',
    });
  };

  vm.disableZoom = () => {
    const disableZoomConfirmationModal = $uibModal.open({
      backdrop: 'static',
      backdropClass: 'modal-overlay-backdrop',
      templateUrl: 'institutions/templates/disable-zoom-confirmation.html',
      windowClass: 'modal-overlay',
    });
    disableZoomConfirmationModal.result.then(() => {
      const zoomType = vm.getZoomIntegrationType();
      InstitutionsManager.disableLiveSessionSettings(zoomType)
        .then((isValid) => {
          if (isValid) {
            InstitutionsManager.institution.liveSessionSettings = {
              apiKey: '',
              apiSecret: '',
              source: _.without(
                InstitutionsManager.institution.liveSessionSettings.source,
                zoomType,
              ),
            };
            InstitutionsManager.institution.zoomEnabled = false;
            AlertMessages.success('FORM.SUCCESS_BANG', 'INSTITUTIONS.ADVANCED_SETTINGS.DISABLE_ZOOM_SUCCESS');
          } else {
            AlertMessages.success('OOPS', 'ERROR_SOMETHING_WRONG');
          }
        });
    });
  };

  vm.disableDegreed = () => {
    const disableZoomConfirmationModal = $uibModal.open({
      backdrop: 'static',
      backdropClass: 'modal-overlay-backdrop',
      templateUrl: 'institutions/templates/disable-degreed-confirmation.html',
      windowClass: 'modal-overlay',
    });
    disableZoomConfirmationModal.result.then(() => {
      InstitutionsManager.saveDegreedSettings('', '')
        .then((isValid) => {
          if (isValid) {
            InstitutionsManager.institution.degreedSettings = null;
            AlertMessages.success('FORM.SUCCESS_BANG', 'INSTITUTIONS.ADVANCED_SETTINGS.DEGREED_INTEGRATION.DISABLE_SUCCESS');
          } else {
            AlertMessages.success('OOPS', 'ERROR_SOMETHING_WRONG');
          }
        });
    });
  };

  vm.disableCalendar = () => {
    const disableMsCalendarConfirmationModal = $uibModal.open({
      backdrop: 'static',
      backdropClass: 'modal-overlay-backdrop',
      templateUrl: 'institutions/templates/disable-ms-calendar-confirmation.html',
      windowClass: 'modal-overlay',
    });
    disableMsCalendarConfirmationModal.result.then(() => {
      InstitutionsManager.disableCalendarSettings(InstitutionsManager.INTEGRATION_TYPES.MS_CALENDAR_USER_LEVEL)
        .then((isValid) => {
          if (isValid) {
            InstitutionsManager.institution.hasMicrosoftCalendarIntegration = null;
            AlertMessages.success('FORM.SUCCESS_BANG', 'INSTITUTIONS.ADVANCED_SETTINGS.MICROSOFT_CALENDAR_INSTITUTION_INTEGRATION.DISABLE_SUCCESS');
          } else {
            AlertMessages.error('FORM.OOPS', 'FORM.ERROR_SOMETHING_WRONG');
          }
        })
        .catch((error) => {
          AlertMessages.error('FORM.OOPS', 'FORM.ERROR_SOMETHING_WRONG');
        });
    });
  };

  vm.disableLms = () => {
    const disableLmsConfirmationModal = $uibModal.open({
      backdrop: 'static',
      backdropClass: 'modal-overlay-backdrop',
      controller: 'ConfigureLmsModalCtrl as vm',
      templateUrl: 'institutions/templates/disable-lms-confirmation.html',
      windowClass: 'modal-overlay',
    });
    disableLmsConfirmationModal.result.then(() => {
      InstitutionsManager.disableLmsIntegration()
        .then(() => {
          InstitutionsManager.institution.lmsConnectionSettings = null;
        })
        .catch(() => {
          AlertMessages.error('FORM.OOPS', 'FORM.ERROR_SOMETHING_WRONG');
        });
    });
  };

  vm.showConfigureBtn = () => {
    const { lmsConnectionSettings } = InstitutionsManager.institution;
    const noSabaConnections = lmsConnectionSettings && !lmsConnectionSettings.sabaDomainName;
    const sumTotalConnections = lmsConnectionSettings?.lms === providerTypes.SUMTOTAL;
    return !lmsConnectionSettings || (noSabaConnections && !sumTotalConnections);
  };

  vm.showSumTotalSection = () => {
    const { lmsConnectionSettings } = InstitutionsManager.institution;
    return lmsConnectionSettings?.lms === providerTypes.SUMTOTAL;
  };

  vm.getProfileLink = () => $state.href('org-level-profile-modal', {
    userId: CurrentUserManager.user.id,
  });

  vm.isLmsEnabled = () => (
    InstitutionsManager.institution.lmsEnabled
  );

  vm.configureOrgLevelProfile = () => {};
  vm.configureOrgLevelMetadata = () => {};
  vm.configureCredly = () => {};
  vm.configureHCMIntegration = () => {};
  vm.downloadOrUploadCSV = () => {};

  function initialize() {
    if ($state.params?.zoom_account_oauth_success === true) {
      AlertMessages.success('FORM.SUCCESS_BANG', 'INSTITUTIONS.ADVANCED_SETTINGS.ENABLE_ZOOM_SUCCESS');
    }
    if ($state.params?.mailbox === false) {
      AlertMessages.error('FORM.OOPS', 'INSTITUTIONS.ADVANCED_SETTINGS.MICROSOFT_CALENDAR_INSTITUTION_INTEGRATION.MAILBOX_FAILURE');
    } else if ($state.params?.redirect === 'outlook') {
      AlertMessages.success('FORM.SUCCESS_BANG', 'INSTITUTIONS.ADVANCED_SETTINGS.MICROSOFT_CALENDAR_INSTITUTION_INTEGRATION.SUCCESS');
    }
  }

  const ProfileSettingsComponent = () => React.createElement(
    OrgLevelProfileSettings,
    {
      forwardShowModal(func) {
        vm.configureOrgLevelProfile = func;
      },
    },
  );

  const CredlySettingsComponent = () => React.createElement(
    CredlySettings,
    {
      forwardShowModal(func) {
        vm.configureCredly = func;
      },
    },
  );

  const HCMIntegrationComponent = () => React.createElement(
    HCMIntegration,
    {
      forwardShowModal(func) {
        vm.configureHCMIntegration = func;
      },
    },
  );

  const HCMDataMappingComponent = () => React.createElement(
    HCMDataMapping,
    {
      forwardShowModal(func) {
        vm.downloadOrUploadCSV = func;
      },
    },
  );

  $scope.ProfileSettingsComponent = ProfileSettingsComponent;
  $scope.CredlySettingsComponent = CredlySettingsComponent;
  $scope.HCMIntegrationComponent = HCMIntegrationComponent;
  $scope.HCMDataMappingComponent = HCMDataMappingComponent;

  vm.disableCredly = () => {
    store.dispatch(openConfirmationDialog({
      title: t.INSTITUTIONS.ADVANCED_SETTINGS.CREDLY.DISABLE(),
      bodyText: t.INSTITUTIONS.ADVANCED_SETTINGS.CREDLY.DISABLE_DESCRIPTION(),
      confirmText: t.FORM.YES_SURE(),
      onConfirm: () => {
        wrapThunkAction(
          store.dispatch(
            disableOrgLevelCredlySettings({
              institutionId: InstitutionsManager.institution.id,
            }),
          ),
        )
          .then(response => {
            store.dispatch(
              addAlertMessage({
                type: AlertMessageType.SUCCESS,
                header: t.INSTITUTIONS.ADVANCED_SETTINGS.CREDLY.SETTINGS_MODAL.SUCCESS_TITLE(),
                message: t.INSTITUTIONS.ADVANCED_SETTINGS.CREDLY.DISABLE_SUCCESS(),
              }),
            );

            InstitutionsManager.institution.updateFromReact({
              ...(response.payload as any).institutionList,
            });
          })
          .catch(() => {
            store.dispatch(
              addAlertMessage({
                type: AlertMessageType.ERROR,
                message: t.FORM.ERROR_SOMETHING_WRONG(),
              }),
            );
          });
      },
    }));
  };

  vm.hasHCMConfig = () => {
    const { hcmConfig = {} } = InstitutionsManager.institution;
    const { endpoint, username, password, integrationType } = hcmConfig;
    return endpoint && username && password && integrationType;
  };

  vm.disableHCM = () => {
    store.dispatch(openConfirmationDialog({
      title: t.INSTITUTIONS.ADVANCED_SETTINGS.HCM.DISABLE(),
      bodyText: t.INSTITUTIONS.ADVANCED_SETTINGS.HCM.DISABLE_DESCRIPTION(),
      confirmText: t.FORM.YES_SURE(),
      cancelDataQa: config.pendo.hcm.integrationCancelDisable,
      confirmDataQa: config.pendo.hcm.integrationConfirmDisable,
      onConfirm: () => {
        const hcmConfig = {
          endpoint: '',
          username: '',
          password: '',
        };

        wrapThunkAction(
          store.dispatch(
            disableHCMIntegration({
              institutionId: InstitutionsManager.institution.id,
              ...hcmConfig,
            } as HCMSettingsPayload),
          ),
        ).then(() => {
          InstitutionsManager.institution.updateFromReact({ hcmConfig });
        });
      },
    }));
  };

  $scope.FileResourceDownloadSwitch = () => (
    <AdvancedSettingsSwitch
      onChange='vm.switchAvailabilityFileDownload(value)'
      dataQa={config.pendo.settings.toggleFileResourceDownload}
      value='vm.InstitutionsManager.institution.allowFileDownloads'
      labelText={$translate.instant('INSTITUTIONS.ADVANCED_SETTINGS.FILE_RESOURCE_DOWNLOAD.LABEL_TEXT')}
    />
  );

  $scope.VideoInsightsSwitch = () => (
    <AdvancedSettingsSwitch
      dataQa='automated-feedback-toggle-org-insights'
      onChange='vm.switchVideoPracticeInsights(value)'
      pendoTagName={config.pendo.settings.insightsSettings}
      value='vm.InstitutionsManager.institution.videoPracticeInsightsEnabled'
    />
  );

  $scope.PromoteMobileAppSwitch = () => (
    <AdvancedSettingsSwitch
      onChange='vm.switchAppPromotion(value)'
      dataQa='toggle-promote-native-mobile-apps'
      pendoTagName={config.pendo.settings.appPromotion}
      value='vm.InstitutionsManager.institution.isAppPromotionEnabled'
    />
  );

  const MetadataComponent = () => React.createElement(
    OrgLevelMetadataSettings,
    {
      forwardShowModal(func) {
        vm.configureOrgLevelMetadata = func;
      },
    },
  );

  $scope.MetadataComponent = MetadataComponent;

  $scope.AutomatedTranslationSwitch = AutomatedTranslationSwitch;
}
